import { Directive, HostListener } from '@angular/core';
import { NeedHelpService } from '../../api/services/need-help.service';

@Directive({
  selector: '[openVirtualAssistant]',
  providers: [NeedHelpService]
})
export class OpenVirtualAssistantDirective {

  constructor(private needHelpService: NeedHelpService) { }

  @HostListener('click', ['$event']) onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.needHelpService.openVirtualAssistant();
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/open-virtual-assistant/open-virtual-assistant.directive.ts